export var MuiMenu = {
    defaultProps: {
        open: false,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        },
    },
    styleOverrides: {
        root: { '& [class*=MuiBackdrop-root]': { background: 'transparent' } },
    },
};
